import type { HttpAdapter } from "../../../core/adapters/axios.adapter"

export interface ArticlePremiumDO {
    premiumContent: string
}


export class ArticleService {
    constructor(private webflowAdapter: HttpAdapter) {
    }

    async get(slug: string, language: string):Promise<ArticlePremiumDO> {
        const response = await this.webflowAdapter.get(`content/article/${slug}/${language}`)
        return response.data
    }
}